import type { Entry } from 'contentful';

import { TypeAccountPopoverSkeleton } from '../models/cms';
import { AccountPopoverData } from '../models';

import { transformNavItem } from './transformNavItem.ts';

export const transformAccountPopover = (entry: Entry<TypeAccountPopoverSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>): AccountPopoverData => {
  const links = entry.fields.links?.filter((x) => !!x).map(transformNavItem) || [];

  return {
    header: entry.fields.header,
    logout: {
      label: entry.fields.logoutLabel,
      icon: entry.fields.logoutIcon,
    },
    links,
    balanceLabel: entry.fields.balanceLabel,
    householdBalanceLabel: entry.fields.householdBalanceLabel,
    membershipNumberLabel: entry.fields.membershipNumberLabel,
    userDataErrorMessage: entry.fields.accountDataError ?? '',
    overlayAriaLabel: entry.fields.overlayAriaLabel,
    triggerAriaLabel: entry.fields.triggerAriaLabel,
  };
};
